import React, { useState } from 'react';
import { ClientOrderContactForm } from './ClientOrderContactForm';
import { clientOrderContactFormValidation } from '../../../../validation/order/ClientOrderContactFormValidation';
import { AddPreExistingClientOrderContactForm } from './AddPreExistingClientOrderContactForm';
import { clientOrderPreExistingContactFormValidation } from '../../../../validation/order/ClientOrderPreExistingContactFormValidation';
import { IFetchDataState } from '../../../../store/IFetchDataState';
import { IAddContactFormProps } from '../interfaces/IAddContactFormProps';
import { NewContactFormik } from '../subComponents/NewContactFormik';
import { IClientUserData } from '../../../../types/clients';
import {
  eContactEnvironment,
  eContactType,
  getContactDuplicationMessage,
} from '../../../../utilities/contact/duplicationErrorMessage';

interface IAddClientOrderContactProps extends IAddContactFormProps {
  preExistingClientContacts: IFetchDataState<string, IClientUserData[]>;
  onSelectContact: (contactId: string) => void;
}

export const AddClientOrderContactForm: React.FC<IAddClientOrderContactProps> = ({
  onCancel,
  onSubmit,
  addFetchError,
  addFetchStatus,
  preExistingClientContacts,
  onSelectContact,
}) => {
  const [addPreExistingContact, setAddPreExistingContact] = useState(true);

  return (
    <NewContactFormik
      title={'New Client Contact'}
      addFetchError={addFetchError}
      addFetchStatus={addFetchStatus}
      addPreExistingContact={addPreExistingContact}
      setAddPreExistingContact={setAddPreExistingContact}
      onCancel={onCancel}
      onSubmit={onSubmit}
      validationSchema={
        addPreExistingContact ? clientOrderPreExistingContactFormValidation : clientOrderContactFormValidation
      }
      duplicateMessage={getContactDuplicationMessage(eContactType.Client, eContactEnvironment.Order)}
    >
      {addPreExistingContact ? (
        <AddPreExistingClientOrderContactForm
          preExistingClientContacts={preExistingClientContacts}
          onSelectContact={onSelectContact}
        />
      ) : (
        <ClientOrderContactForm emailReadOnly={false} />
      )}
    </NewContactFormik>
  );
};
